import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import JoditEditor, { Jodit } from 'jodit-react';
import { getRepEmailTemplates, deleteRepEmailTmplate, addRepEmailTemplate, updateRepEmailTemplate } from '../../services/RepEmailTemplateService';
import { toast, confirm } from '@rickylandino/react-messages';
import { Empty, Spin, Alert, message } from 'antd';
/*import { activeUserInfo } from '../../services/UsersService';*/
import { Fragment } from 'react';
import Axios from '../../config/axios';
import { sendRepEmail } from '../../services/EmailSenderService';

export default function WidgetRepEmailTemplateLibrary(props) {
    const { register, getValues, setValue, watch } = useForm();
    const editor = useRef(null);
    const [content, setContent] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [selectedTemplateType, setSelectedTemplateType] = useState(null);
    const [templateDropdown, setTemplateDropdown] = useState([]);
    const [emailSignatures, setEmailSignatures] = useState([]);
    const [emailTemplates, setEmailTemplates] = useState([]);
    const [mergeFields, setMergeFields] = useState([]);
    const [repEmailImages, setRepEmailImages] = useState([]);
    const [editorSignatures, setEditorSignatures] = useState({});
    const [editorMergeFields, setEditorMergeFields] = useState([]);
    const [editorImages, setEditorImages] = useState({});
    const [fileList, setFileList] = useState([]);   //this is just so we can create an empty arrary of file attachments in order to use common sendRepEmail service
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    const [state, setState] = useState({
        dataLoaded: false
    });

    // DnD overlay state
    const [dndOverlayActive, setDndOverlayActive] = useState(false);
    const [dndOverlayHighlight, setDndOverlayHighlight] = useState(false);

    // DnD overlay logic (scoped to editor area)
    useEffect(() => {
        let dragCounter = 0;
        function onDragEnter(e) {
            if (e.dataTransfer && e.dataTransfer.types && Array.from(e.dataTransfer.types).includes('Files')) {
                dragCounter++;
                setDndOverlayActive(true);
                setDndOverlayHighlight(true);
            }
        }
        function onDragOver(e) {
            if (e.dataTransfer && e.dataTransfer.types && Array.from(e.dataTransfer.types).includes('Files')) {
                e.preventDefault();
                setDndOverlayHighlight(true);
            }
        }
        function onDragLeave(e) {
            dragCounter--;
            if (dragCounter <= 0) {
                setDndOverlayHighlight(false);
                setDndOverlayActive(false);
                dragCounter = 0;
            }
        }
        function onDrop(e) {
            dragCounter = 0;
            setDndOverlayHighlight(false);
            setDndOverlayActive(false);
        }
        window.addEventListener('dragenter', onDragEnter);
        window.addEventListener('dragover', onDragOver);
        window.addEventListener('dragleave', onDragLeave);
        window.addEventListener('drop', onDrop);
        return () => {
            window.removeEventListener('dragenter', onDragEnter);
            window.removeEventListener('dragover', onDragOver);
            window.removeEventListener('dragleave', onDragLeave);
            window.removeEventListener('drop', onDrop);
        };
    }, []);

    // Overlay drop handler
    function handleOverlayDrop(e) {
        e.preventDefault();
        setDndOverlayHighlight(false);
        setDndOverlayActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0];
            if (file.type === 'text/html' || file.name.endsWith('.html') || file.name.endsWith('.htm')) {
                const reader = new window.FileReader();

                //this replaces all content in the editor
                //reader.onload = function (evt) {
                //    setContent(evt.target.result);
                //};

                //this appends the dropped file at the end of the content
                reader.onload = (evt) => {
                    setContent(prev => (prev || '') + evt.target.result);
                };

                reader.readAsText(file);
            } else {
                toast.error("Only HTML files are allowed (.html or .htm)");
                /*alert('Only HTML files are allowed (.html or .htm)');*/
            }
        }
    }

    useEffect(() => {
        setState({
            ...state,
            dataLoaded: false
        });

        Axios.get(`/api/InitializeEmailSender`, {
            params: {
                ownedby: userInfo.userId,
                division: userInfo.jobShopDivision
            }
        }).then(response => {
            let templates = [];
            let signatures = [];

            setValue('repDocuments', response.data.repDocuments);

            for (var i = 0; i < response.data.templates.length; i++) {
                if (response.data.templates[i].templateType === 'email') {
                    if (response.data.templates[i].shared === true && response.data.templates[i].ownedBy !== userInfo.userId) {
                        response.data.templates[i].templateName += ' (shared by ' + response.data.templates[i].ownedBy + ')';
                    }
                    templates.push(response.data.templates[i]);
                }
                else {
                    signatures.push(response.data.templates[i]);
                }
            }

            setEmailTemplates(templates);
            setEmailSignatures(signatures);
            setRepEmailImages(response.data.repEmailImages);

            //load email signatures for editor dropdown
            //let editorSignatures = {};
            //signatures.filter(et => et.templateType === 'signature')
            //    .forEach(et => {
            //        editorSignatures[et.repEmailTemplateLibrary_ID] = et.templateName
            //    });
            //setEditorSignatures(editorSignatures);

            //load merge fields for editor dropdown
            let mergeFields = ["Contact Name", "Company Name"];
            setMergeFields(mergeFields);

            setTemplateDropdown(templates);

            setValue('testEmailRecipient', userInfo.email);
            setValue('selectedRepDocuments', []);   //this is just so we can create an empty arrary of rep documents in order to use common sendRepEmail service

            setState({
                ...state,
                dataLoaded: true
            });
        }).catch(error => {
            console.log(error);
        });
    }, [props]);


    useEffect(() => {
        if (state.dataLoaded === true) {
            setSelectedTemplateType('email');
            setTemplateDropdown(emailTemplates);

            setSelectedTemplate(null);
            setValue('templateName', '');
            setValue('templateSubject', '');
            setValue('sharedOrPivate', 'Private');
            setValue('saveButtonText', 'Add New Template');
            setContent('');
        }
    }, [state.dataLoaded]);

    useEffect(() => {
        setSelectedTemplate(null);
        setValue('templateName', '');
        setValue('templateSubject', '');
        setValue('sharedOrPivate', 'Private');
        setValue('saveButtonText', 'Add New Template');
        setContent('');

        if (selectedTemplateType === 'email') {
            setTemplateDropdown(emailTemplates);
        }
        else {
            setTemplateDropdown(emailSignatures);
        }
    }, [selectedTemplateType]);

    //****************************
    //Jodit Editor custom buttons
    //****************************
    useEffect(() => {
        if (!emailSignatures?.length) return;

        const signatureList = {};

        emailSignatures.forEach(sig => {
            const commandName = `sig_${sig.repEmailTemplateLibrary_ID}`;

            // register the command ONCE
            Jodit.defaultOptions.controls[commandName] = {
                exec: (editor) => {
                    editor.s.insertHTML(
                        `<div id="signature">${sig.stringContent}</div>`
                    );
                }
            };

            // dropdown item points to the command
            signatureList[commandName] = {
                text: sig.templateName
            };
        });

        setEditorSignatures(signatureList);
    }, [emailSignatures]);

    useEffect(() => {
        if (!mergeFields?.length) return;

        const mergeFieldList = {};

        mergeFields.forEach(field => {
            const commandName = `merge_${field.replace(/\s+/g, '_')}`; // unique command name

            // register command
            Jodit.defaultOptions.controls[commandName] = {
                exec: (editor) => {
                    editor.s.insertHTML('[[' + field + ']]');
                }
            };

            // add to dropdown list
            mergeFieldList[commandName] = {
                text: field
            };
        });

        setEditorMergeFields(mergeFieldList); // you�ll need a separate state
    }, [mergeFields]);

    useEffect(() => {
        if (!repEmailImages?.length) return;

        const imageList = {};

        repEmailImages.forEach(img => {
            // sanitize key
            const commandName = `img_${img.replace(/[^a-zA-Z0-9_]/g, '_')}`;

            // register command
            if (!Jodit.defaultOptions.controls[commandName]) {
                Jodit.defaultOptions.controls[commandName] = {
                    exec: (editor) => {
                        editor.s.insertHTML(
                            `<a href="https://d2p-show-rep-email-images.nyc3.digitaloceanspaces.com/${encodeURIComponent(img)}">
                            <img src="https://d2p-show-rep-email-images.nyc3.digitaloceanspaces.com/${encodeURIComponent(img)}" />
                        </a>`
                        );
                    }
                };
            }

            imageList[commandName] = { text: img };
        });

        setEditorImages(imageList); // reactive state
    }, [repEmailImages]);
    //********************************
    //End Jodit Editor custom buttons
    //********************************

    function selectTemplate(e) {
        e.preventDefault();
        let target = e.target;
        let name = target.name;
        let value = target.value;

        if (value !== '<Add New>') {
            let foundTemplate = templateDropdown.find(t => t.repEmailTemplateLibrary_ID === parseInt(value));

            if (foundTemplate) {
                setSelectedTemplate(foundTemplate);
                setValue('selectedTemplateText', foundTemplate.repEmailTemplateLibrary_ID);
                setValue('templateName', foundTemplate.templateName);
                setValue('templateSubject', foundTemplate.templateSubject);
                if (foundTemplate.shared === true) {
                    setValue('sharedOrPrivate', 'Shared');
                }
                else {
                    setValue('sharedOrPrivate', 'Private');
                }
                setValue('saveButtonText', 'Update Template');
                setContent(foundTemplate.stringContent);
            } else {
                setSelectedTemplate(null);
                setValue('selectedTemplateText', null);
                setValue('templateName', '');
                setValue('templateSubject', '');
                setValue('sharedOrPrivate', 'Private');
                setValue('saveButtonText', 'Add New Template');
                setContent('');
            }
        } else {
            setSelectedTemplate(null);
            setValue('selectedTemplateText', null);
            setValue('templateName', '');
            setValue('templateSubject', '');
            setValue('sharedOrPrivate', 'Private');
            setValue('saveButtonText', 'Add New Template');
            setContent('');
        }
    }

    function selectTemplateType(e) {
        e.preventDefault();
        let target = e.target;
        let name = target.name;
        let value = target.value;

        setValue('sharedOrPrivate', 'Private');
        setSelectedTemplateType(value);
    }

    function handleSubmit() {
        var mySharedOrPrivate;

        if (getValues().sharedOrPrivate === null) {
            toast.error("You must specify if the template is Private or Shared");
            return;
        }

        if (getValues().sharedOrPrivate === 'Private' || selectedTemplateType === 'Signature') {
            mySharedOrPrivate = false;
        }
        else {
            mySharedOrPrivate = true;
        }

        if (getValues().templateName) {
            if (selectedTemplate) {
                let postdata = {
                    repEmailTemplateLibrary_ID: selectedTemplate.repEmailTemplateLibrary_ID,
                    templateType: selectedTemplateType,
                    templateName: getValues().templateName,
                    templateSubject: getValues().templateSubject,
                    stringContent: content,
                    ownedBy: userInfo.userId,
                    division: userInfo.jobShopDivision,
                    shared: mySharedOrPrivate
                };

                updateRepEmailTemplate(postdata).then(data => {
                    if (data?.repEmailTemplateLibrary_ID) {
                        var newList;
                        if (selectedTemplateType === 'email') {
                            newList = [...emailTemplates];
                        }
                        else {
                            newList = [...emailSignatures];
                        }

                        let idx = newList.findIndex(item => item.repEmailTemplateLibrary_ID === parseInt(data.repEmailTemplateLibrary_ID));
                        if (idx >= 0) {
                            newList[idx] = data;
                            newList[idx].stringContent = content;

                            if (selectedTemplateType === 'email') {
                                setEmailTemplates(newList);
                            }
                            else {
                                setEmailSignatures(newList);
                            }
                            setTemplateDropdown(newList);

                            toast.success("Your email template has been updated");
                        }
                    } else {
                        toast.error("Something went wrong");
                    }
                });

            } else {
                //add template
                let postdata = {
                    templateType: selectedTemplateType,
                    templateName: getValues().templateName,
                    templateSubject: getValues().templateSubject,
                    stringContent: content,
                    ownedBy: userInfo.userId,
                    division: userInfo.jobShopDivision,
                    shared: mySharedOrPrivate
                };

                addRepEmailTemplate(postdata).then(data => {
                    if (data?.repEmailTemplateLibrary_ID) {
                        setSelectedTemplate(data);

                        var newList;
                        if (selectedTemplateType === 'email') {
                            newList = [...emailTemplates];
                            data.stringContent = content;
                            newList.push(data);
                            setEmailTemplates(newList);
                        }
                        else {
                            newList = [...emailSignatures];
                            data.stringContent = content;
                            newList.push(data);
                            setEmailSignatures(newList);
                        }
                        setTemplateDropdown(newList);

                        toast.success("Your email template has been added");
                    } else {
                        toast.error("Something went wrong")
                    }
                });
            }
        } else {
            toast.error("Template Name is a required field");
        }
    }

    function handleDeleteRepEmailTemplate() {
        confirm({
            title: <span><i className='far fa-trash-alt text-danger icon-md pr-1'></i> &nbsp; You are about to permanently delete this email template.</span>,
            content: "Are you sure you would like to proceed? This action cannot be undone.",
            buttons: ["Yes", "No"],
            theme: window.sessionStorage.getItem("theme") === 'dark' ? 'dark' : 'light'
        }, (buttonPressed) => {
            if (buttonPressed === 'Yes') {
                let postdata = selectedTemplate;

                console.log(postdata);

                deleteRepEmailTmplate(postdata).then(data => {
                    if (data) {
                        setValue('selectedTemplateText', '<Add New>');
                        setSelectedTemplate(null);
                        setValue('templateName', '');
                        setValue('templateSubject', '');
                        setValue('sharedOrPivate', 'Private');
                        setValue('saveButtonText', 'Add New Template');
                        setContent('');

                        var newList;
                        if (selectedTemplateType === 'email') {
                            newList = [...emailTemplates];
                            newList = newList.filter(t => t.repEmailTemplateLibrary_ID != selectedTemplate.repEmailTemplateLibrary_ID);
                            setEmailTemplates(newList);
                        }
                        else {
                            newList = [...emailSignatures];
                            newList = newList.filter(t => t.repEmailTemplateLibrary_ID != selectedTemplate.repEmailTemplateLibrary_ID);
                            setEmailSignatures(newList);
                        }
                        setTemplateDropdown(newList);

                        toast.success("Email Template has been deleted");
                    } else {
                        toast.error("Something went wrong");
                    }
                });

                return 0;
            } else {
                return 0;
            }
        });
    }

    function handlePrivacyIndicatorChange(e) {
        let target = e.target;
        /*let name = target.name;*/
        let value = target.value;

        setValue('sharedOrPrivate', value);

        setState({
            ...state,
        });
    }

    var joditButtons = [...Jodit.defaultOptions.buttons];

    if (selectedTemplateType !== 'signature') {
        joditButtons.push({
            name: 'Signatures',
            text: 'Signatures',
            list: editorSignatures
        });
        joditButtons.push({
            name: 'Merge Fields',
            text: 'Merge Fields',
            list: editorMergeFields
        });
        joditButtons.push({
            name: 'Email Images',
            text: 'Email Images',
            list: editorImages
        });
    }
    else {

    }

    //var joditButtons = [...Jodit.defaultOptions.buttons];

    //if (selectedTemplateType !== 'signature') {
    //    joditButtons.push({
    //        name: 'Signatures',
    //        list: editorSignatures,
    //        exec: (ed, nodeOrFalse, control, origEvent, btn) => {
    //            console.log(control.control.name);

    //            let foundTemp = emailSignatures?.find(es => es.repEmailTemplateLibrary_ID === parseInt(control.control.name));
    //            if (foundTemp) {
    //                ed.s.insertHTML("<div id=\"signature\"" + foundTemp.stringContent + "</div>");
    //            }
    //        }
    //    });
    //    joditButtons.push({
    //        name: 'Merge Fields',
    //        list: editorMergeFields,
    //        exec: (ed, nodeOrFalse, control, origEvent, btn) => {
    //            let foundField = editorMergeFields?.find(emf => emf === control.control.name);
    //            if (foundField) {
    //                ed.s.insertHTML('[[' + control.control.name + ']]');
    //            }
    //        }
    //    });
    //    joditButtons.push({
    //        name: 'Email Images',
    //        list: repEmailImages,
    //        exec: (ed, nodeOrFalse, control, origEvent, btn) => {
    //            let foundImage = repEmailImages?.find(rei => rei === control.control.name);

    //            console.log(foundImage);

    //            if (foundImage) {
    //                ed.s.insertHTML(
    //                    `<a href="https://d2p-show-rep-email-images.nyc3.digitaloceanspaces.com/${encodeURIComponent(foundImage)}">
    //                     <img src="https://d2p-show-rep-email-images.nyc3.digitaloceanspaces.com/${encodeURIComponent(foundImage)}" />
    //                   </a>`
    //                );
    //            }
    //        }
    //    });
    //} else {
    //    let sigIdx = joditButtons.findIndex(jb => jb.name === 'Signatures');
    //    if (sigIdx >= 0) {
    //        joditButtons.splice(sigIdx, 1);
    //    }
    //}

    function handleCopyTemplate() {
        setValue('selectedTemplateText', '<Add New>');
        setSelectedTemplate(null);
        setValue('templateName', '');
        setValue('saveButtonText', 'Add New Template');
    }

    function handleSendTestEmail() {
        const isEditorEmpty =
            !content ||
            content.trim() === '<p><br></p>' ||
            content.trim() === '<p></p>';

        if (getValues().testEmailRecipient.trim() === '' || getValues().templateSubject.trim() === '' || isEditorEmpty) {
            toast.error("Test Email Recipient, Subject and Body Content are required fields");

            return;
        }

        // Validate list of sendTo and sendCC email addresses
        var validator = require("node-email-validation");
        var splitList;

        //Validate list of testEmailRecipient email address
        if (getValues().testEmailRecipient.includes(";")) {
            splitList = getValues().testEmailRecipient.split(';');
        }
        else if (getValues().testEmailRecipient.includes(",")) {
            splitList = getValues().testEmailRecipient.split(',');
        }
        if (splitList === undefined) {
            if (validator.is_email_valid(getValues().testEmailRecipient) === false) {
                toast.error("Invalid format found for 'Test Email' address");
                return;
            }
        }
        else {
            for (let i = 0; i < splitList.length; i++) {
                if (validator.is_email_valid(splitList[i].trim()) === false) {
                    toast.error("Invalid format found for 'Email Test' addresses");
                    return;
                }
            }
        }

        const key = "sendEmail";
        message.loading({
            content: 'Sending Test Email...',
            key,
            duration: 0,
            style: {
                position: "fixed",
                bottom: 0,
                left: 0
            },
        });

        sendRepEmail(userInfo.userId, getValues().testEmailRecipient, "", getValues().templateSubject.trim(), content, getValues().selectedRepDocuments, fileList, false).then(data => {
            message.destroy(key);

            if (data.includes("Success:")) {
                toast.success(data.replace("Success:", ""));
            }
            else if (data.includes("Error:")) {
                toast.error(data.replace("Error:", ""));
            }
        }).catch(error => {
            toast.error("Problem encountered sending test email");
        });
    }

    return (
        <div className="row">
            <Spin spinning={!state.dataLoaded}>
                <div style={!state.dataLoaded ? {} : { display: 'none' }}>
                    <Alert
                        message="Loading Rep Templates"
                        description="Please stand by while we retrieve your email templates & signatures"
                        type="info"
                    />
                </div>
                {state.dataLoaded &&
                    <Fragment>
                        <div className="row">
                            <div className="form-group col-lg-3 col-12">
                                <label>Template Type</label>
                                <select className="ant-input" onChange={selectTemplateType}>
                                    <option value='email'>Email</option>
                                    <option value='signature'>Signature</option>
                                </select>
                            </div>

                            <div className="horizontal-campaigns-divider"></div>

                            <div className="form-group col-lg-5 col-12">
                                <label>Selected Template</label>
                                <select className="ant-input" onChange={selectTemplate} value={selectedTemplate?.repEmailTemplateLibrary_ID || 0}>
                                    <option value={null}>{'<Add New>'}</option>
                                    {templateDropdown.map((t, idx) => <option key={idx} value={t.repEmailTemplateLibrary_ID}>{t.templateName}</option>)}

                                </select>
                                {/*<select className="ant-input" onChange={selectTemplate} value={selectedTemplate?.repEmailTemplateLibrary_ID || null}>*/}
                                {/*    <option value={null}>{'<Add New>'}</option>*/}
                                {/*    {templateDropdown.map((t, idx) => <option key={idx} value={t.repEmailTemplateLibrary_ID}>{t.templateName}</option>)}*/}

                                {/*</select>*/}
                            </div>

                            <div className="form-group col-lg-8 col-12">
                                <label>Template Name <span className="text-danger">*</span></label>
                                <input className="ant-input" {...register('templateName')} />
                            </div>

                            <div className="form-group col-lg-8 col-12" style={selectedTemplateType === 'email' ? {} : { display: 'none' }}>
                                <label>Email Subject</label>
                                <input className="ant-input" {...register('templateSubject')} />
                            </div>

                            <div className="col col-12">
                                <div style={{ position: 'relative' }}>
                                    <JoditEditor
                                        ref={editor}
                                        value={content}
                                        tabIndex={1}
                                        onBlur={(newContent) => setContent(newContent)}
                                        onChange={(newContent) => { }}
                                        config={{
                                            height: "480",
                                            allowResizeY: true,
                                            spellcheck: true,
                                            uploader: {
                                                insertImageAsBase64URI: true
                                            },
                                            buttons: joditButtons,
                                            removeButtons: ['source', 'about', 'video', 'file', 'fullsize', 'preview', 'image'],
                                            readonly: false,
                                            iframe: false,
                                            pasteHTML: true,
                                            askBeforePasteHTML: false,
                                            pasteFromWord: true,
                                            cleanHTML: {
                                                removeEmptyElements: false,
                                                removeEmptyAttributes: false,
                                            }
                                        }}
                                    />
                                    {dndOverlayActive && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                zIndex: 10,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                pointerEvents: 'auto',
                                                background: dndOverlayHighlight ? 'rgba(25, 118, 210, 0.10)' : 'rgba(25, 118, 210, 0.04)',
                                                transition: 'background 0.2s',
                                            }}
                                            onDragOver={e => { e.preventDefault(); setDndOverlayHighlight(true); }}
                                            onDragLeave={e => { e.preventDefault(); setDndOverlayHighlight(false); }}
                                            onDrop={handleOverlayDrop}
                                        >
                                            <div
                                                style={{
                                                    border: dndOverlayHighlight ? '2px solid #1976d2' : '2px dashed #1976d2',
                                                    borderRadius: 8,
                                                    padding: 48,
                                                    background: '#f8faff',
                                                    color: '#1976d2',
                                                    fontWeight: 600,
                                                    fontSize: 22,
                                                    boxShadow: dndOverlayHighlight ? '0 0 16px #1976d2' : 'none',
                                                    transition: 'all 0.2s',
                                                }}
                                            >
                                                Drop HTML file to load content
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div style={selectedTemplateType === 'email' ? {} : { display: 'none' }}>
                                <p></p>
                                <label className="form-label">Shared or Private:</label>&nbsp;&nbsp;
                                <input type="radio" name="privacyIndicator" value="Private" className="mt-1" {...register('sharedOrPrivate')} checked={getValues().sharedOrPrivate === "Private"} onChange={handlePrivacyIndicatorChange} />&nbsp;<label className="form-label">Private Template</label>&nbsp;&nbsp;&nbsp;
                                <input type="radio" name="privacyIndicator" value="Shared" className="mt-1" {...register('sharedOrPrivate')} checked={getValues().sharedOrPrivate === "Shared"} onChange={handlePrivacyIndicatorChange} />&nbsp;<label className="form-label">Shared Template</label>&nbsp;&nbsp;&nbsp;
                            </div>

                            <div className="col col-12 mt-3">
                                <div className="d-flex align-items-start justify-content-between flex-wrap gap-3 w-100">

                                    {/* LEFT SIDE */}
                                    <div className="d-flex align-items-center gap-2">
                                        <button className="ant-btn ant-btn-primary" onClick={handleSubmit}>
                                            {getValues().saveButtonText}
                                        </button>

                                        {getValues().saveButtonText === 'Update Template' &&
                                            <button className="ant-btn ant-btn-primary" onClick={handleCopyTemplate}>
                                                Copy Template
                                            </button>
                                        }

                                        {selectedTemplate?.repEmailTemplateLibrary_ID &&
                                            <button className="ant-btn ant-btn-danger" onClick={handleDeleteRepEmailTemplate}>
                                                <i className='far fa-trash-alt'></i> &nbsp; Delete this Template
                                            </button>
                                        }
                                    </div>

                                    {/* RIGHT SIDE */}
                                    <div style={{ minWidth: '420px' }}>
                                        <div className="d-flex align-items-center gap-2">
                                            <label className="mb-0">
                                                Send Test Email To:
                                            </label>

                                            <input
                                                className="inline-text-box"
                                                type="text"
                                                {...register("testEmailRecipient")}
                                                style={{ width: "375px" }}
                                            />

                                            <button className="ant-btn ant-btn-primary" onClick={handleSendTestEmail}>
                                                Send Test Email
                                            </button>
                                        </div>

                                        <div className="text-muted small mt-1">
                                            Add more email addresses delimited by a comma
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Fragment>
                }
            </Spin>

        </div>
    );
}